/* unplugin-vue-components disabled */import { render } from "./AdCard.vue?vue&type=template&id=c75cecdc&scoped=true"
import script from "./AdCard.vue?vue&type=script&lang=js"
export * from "./AdCard.vue?vue&type=script&lang=js"

import "./AdCard.vue?vue&type=style&index=0&id=c75cecdc&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c75cecdc"]])

export default __exports__